import { render } from "./MainHome.vue?vue&type=template&id=7b4ce62e"
import script from "./MainHome.vue?vue&type=script&lang=js"
export * from "./MainHome.vue?vue&type=script&lang=js"

import "./MainHome.vue?vue&type=style&index=0&id=7b4ce62e&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\tink\\tink-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__